let data = {
    'instant-noodles': {
        'sedaap': [
            {
                'nama': 'kari-ayam',
                'rate': 'C',
                'img_format': 'png',
                'note': [
                    'basic'
                ]
            },
            {
                'nama': 'ayam-bawang',
                'rate': 'B',
                'img_format': 'png',
                'note': [
                    '...'
                ]
            },
            {
                'nama': 'baso-spesial',
                'rate': 'A',
                'img_format': 'png',
                'note': [
                    '...'
                ]
            },
        ],
        'indomie': [
            {
                'nama': 'ayam-bawang',
                'rate': 'C',
                'img_format': 'png',
                'note': [
                    'hanya punya bumbu, bubuk cabai, dan minyak -_-'
                ]
            },
            {
                'nama': 'soto-makassar',
                'rate': 'D',
                'img_format': 'png',
                'note': [
                    'pedis tapi yaa masih bisa lahh'
                ]
            },
            {
                'nama': 'soto-banjar-limau-kulit',
                'rate': 'A',
                'img_format': 'png',
                'note': [
                    'the lime kicks in perfectly'
                ]
            },
            {
                'nama': 'soto-spesial',
                'rate': 'C',
                'img_format': 'png',
                'note': [
                    'ordinary tasty'
                ]
            },
            {
                'nama': 'kaldu-ayam',
                'rate': 'C',
                'img_format': 'png',
                'note': [
                    'b aj'
                ]
            },
            {
                'nama': 'kari-ayam',
                'rate': 'A',
                'img_format': 'png',
                'note': [
                    "definitely the standard taste of an A"
                ]
            },
            {
                'nama': 'mi-goreng',
                'rate': 'B',
                'img_format': 'png',
                'note': [
                    "kind of an original taste"
                ]
            },
            {
                'nama': 'soto-lamongan',
                'rate': 'B',
                'img_format': 'png',
                'note': [
                    "..."
                ]
            },
        ]
    }, 
    'milk': {
        'indomilk': [],
    },
    'can-coffee': {
        'nescafe': [
            {
                'nama': 'latte',
                'rate': 'B',
                'img_format': 'png',
                'note': [
                    "..."
                ]
            },
        ],
    },
};

export default data;
